import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBy1w9R-i5SoD3hntNRK8uu-HgS8xwVgy8',
  authDomain: 'aidenywl-personal.firebaseapp.com',
  projectId: 'aidenywl-personal',
  storageBucket: 'aidenywl-personal.firebasestorage.app',
  messagingSenderId: '31141270893',
  appId: '1:31141270893:web:421377df09663ac439b664',
  measurementId: 'G-2E3PP7SSCN',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
